export default import.meta.ROLLUP_FILE_URL_OaaM5uC8Px77nfrNqjhIeA